const CommonTitle = ({ title }) => {
  return (
    <h2 className="text-3xl ss:text-4xl md:text-5xl leading-normal sm:leading-relaxed md:leading-relaxed font-semibold">
      {title}
    </h2>
  );
};
  
export default CommonTitle;